// Ported from crehana-frontend-apps: apps/crehana-frontend/src/views/CrehanaLegal/i18n/localeEs.tsx (FRONT-216)
import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    MENU_TITLE: 'Contenido',
    UPDATED_AT: 'Fecha de última actualización:',
    GO_BACK: 'Regresar',
    TERMS_AND_CONDITIONS_TITLE: 'Términos y condiciones',
    TERMS_AND_CONDITIONS_B2B_TITLE: 'Términos y condiciones B2B',
    TERMS_AND_CONDITIONS_B2B_EN_TITLE: 'Terms and conditions B2B',
    PRIVACY_TITLE: 'Políticas de privacidad y protección de datos personales',
    AUTHORIZATION_FOR_PROCESSING_PERSONAL_DATA_ATS_TITLE:
      'Autorización para el Tratamiento de Datos Personales ATS',
    PERSONAL_DATA_PROTECTION_POLICY_CREHANA_ATS_TITLE:
      'Política protección de datos personales CREHANA ATS',
    PRIVACY_PE_LABEL: 'Perú',
    PRIVACY_CO_LABEL: 'Colombia',
    PRIVACY_CL_LABEL: 'Chile',
    PRIVACY_MX_LABEL: 'México',
    PRIVACY_NOTICE_MX_TITLE: 'Avisos de privacidad (México)',
    PRIVACY_NOTICE_CO_TITLE: 'Avisos de privacidad (Colombia)',
    MEMBERSHIP_POLICY_TITLE: 'Políticas de Membresías',
    MEMBERSHIP_POLICY_PREMIUM_LABEL: 'Premium individual',
    MEMBERSHIP_POLICY_DUO_LABEL: 'Premium Dúo',
    MEMBERSHIP_POLICY_FAMILY_LABEL: 'Premium Familiar',
    MEMBERSHIP_POLICY_STUDENT_LABEL: 'Estudiantil',
    PAYG_POLICY_TITLE: 'Políticas de Pay As You Go',
    TEACHER_AGREEMENT_TITLE: 'Acuerdo para profesores',
    COOKIES_POLICY_TITLE: 'Política de cookies',
    ARCO_REQUEST_TITLE: 'Solicitud ARCO',
    REFUND_POLICY_TITLE: 'Politicas de reembolso',
    SECURITY_AND_PRIVACY_POLICY_TITLE:
      'Política general de seguridad y privacidad de la información',
    SLA_TITLE: 'Service Level Agreement (SLA)',
  },
};

export default es;
